module.exports = __webpack_public_path__ + "img/add.0457fd2b.png";